// extracted by mini-css-extract-plugin
export default {"component":"marketQuestionDialog__component___1T+V9"};